import { BreakpointsContext } from 'contexts/BreakpointsContext'
import useCustomContext from './useCustomContext'

const useBreakpoints = () => {
  return useCustomContext(BreakpointsContext, useBreakpoints.name)
}

export default useBreakpoints
